<template>
  <div class="inscription">
    <ConnectionForm />
  </div>
</template>

<script>
import ConnectionForm from "@/components/ConnectionForm";

export default {
  name: "Inscription",
  components: {
    ConnectionForm
  },
  siteNo: 0,
  siteName: "Idylive",
  data() {
    return {
      msg: "Inscription"
    };
  }
};
</script>

<style scoped></style>
